import { FormBase } from 'core/components';

export default class TrackingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'carrierId',
					label: 'FULFILLMENTORDER.TRACKINGMODAL.CARRIER',
					rules: 'required',
				},
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.TRACKINGMODAL.TRACKINGNUMBER',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/TrackingForm.js